import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-simple-confirmation',
    templateUrl: './simple-confirmation.component.html',
    styleUrl: './simple-confirmation.component.scss',
    standalone: false
})
export class SimpleConfirmationComponent {
  constructor(
    public dialogRef: MatDialogRef<SimpleConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.dialogRef.addPanelClass(['md-w-400-px']);
  }

  onClose(status: boolean | null): void {
    this.dialogRef.close(status);
  }
}
